<template>
  <div class="loginstep">
    <div class="step-item" :class="{ active: activity >= 1 }">
      <div class="border"></div>
      <div class="content">1</div>
      <div class="border"></div>
    </div>
    <div class="step-item" :class="{ active: activity >= 2 }">
      <div class="border"></div>
      <div class="content">2</div>
      <div class="border"></div>
    </div>
    <div class="step-item" :class="{ active: activity >= 3 }">
      <div class="border"></div>
      <div class="content">3</div>
      <div class="border"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loginstep",
  props: {
    activity: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.loginstep {
  height: 44px;
  display: flex;
  justify-content: center;

  .step-item {
    display: flex;
    align-items: center;

    .border {
      width: 128px;
      background-color: #4b5053;
      height: 1px;
      color: #fff;
      //             .el-input__inner {
      //     color: #fff;
      //     background-color: #212429 !important;
      //     border-color: #4b5053 !important;
      //   }
    }

    .content {
      width: 44px;
      height: 44px;
      background-color: #212429;
      border-radius: 50%;
      // color: #D9D9D9;
      text-align: center;
      line-height: 44px;
    }
  }
}

.active {
  .border {
    background-color: #50a3f1 !important;
  }
  .content {
    background-color: #50a3f1 !important;
    color: white !important;
  }
}
</style>
